import { render, staticRenderFns } from "./FormTindakan.vue?vue&type=template&id=e9136566&"
import script from "./FormTindakan.vue?vue&type=script&lang=js&"
export * from "./FormTindakan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports